<ng-container *ngIf="customer; else missingCustomer">
    <div class="tabs-wrapper">
        <a (click)="closeDrawer()" style="width: 60px">
            <i class="fas fa-xmark"></i>
        </a>
        <a
            (click)="activeView = 'inbox'"
            [ngClass]="{ selected: activeView === 'inbox' }"
        >
            <i class="fas fa-envelope"></i>
        </a>
        <a
            (click)="activeView = 'chat'"
            [ngClass]="{ selected: activeView === 'chat' }"
        >
            <i class="fas fa-comments"></i>
        </a>
        <a
            nz-tooltip="Start Video Session"
            (click)="
                activeView === 'chat' ? joinVideo() : (activeView = 'chat')
            "
        >
            <i class="fas fa-video"></i>
        </a>
    </div>
    <div
        style="
            width: 100%;
            display: flex;
            gap: 5px;
            padding: 5px;
            background: #efefef;
            text-align: center;
        "
    >
        <b>
            {{ customer.firstName + ' ' + customer.lastName | titlecase }}
        </b>
        <div style="flex: 1"></div>
        <patient-presence-status
            [customerId]="customer._id"
        ></patient-presence-status>
        <nz-tag>
            <a nz-tooltip="SMS Ping Patient" (click)="ping()">
                Ping
                <i class="fas fa-bell"></i>
            </a>
        </nz-tag>
        <nz-tag>
            <a nz-tooltip="Forward to Customer Service" (click)="forwardCS()">
                CS
                <i class="fas fa-paper-plane"></i>
            </a>
        </nz-tag>
        <nz-tag>
            <a nz-tooltip="Forward to Pharmacy" (click)="forwardPH()">
                PH
                <i class="fas fa-paper-plane"></i>
            </a>
        </nz-tag>
    </div>

    <portals-provider-chat-inbox
        class="scrollable"
        [customerId]="customer._id"
        *ngIf="activeView === 'inbox'"
    >
    </portals-provider-chat-inbox>

    <portals-provider-chat-messages
        class="scrollable"
        [customerId]="customer._id"
        *ngIf="activeView === 'chat'"
    ></portals-provider-chat-messages>
</ng-container>
<ng-template #missingCustomer>
    <p>Loading patient…</p>
</ng-template>
